import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getSecondaryColor } from '../../services/get-colors';
import { hideNewPostMessage } from '../../actions/hide-new-post-message';
import withTranslate from '../../hoc/with-translate';
import Link from '../../components/link/internal-link';
import styles from './new-post-message.scss';

class NewPostMessage extends Component {
  state = {};

  render() {
    const { header, pathname, onClick, t } = this.props;
    const transform = `translate3d(0, ${header.offset + header.height + 10 || 0}px, 0)`;
    const style = {
      transform,
      backgroundColor: getSecondaryColor(),
    };

    const to = `${pathname}#${this.props.postId}`;
    return (
      <Link to={to} className={styles.container} style={style} onClick={onClick}>
        {t('new-post-message.new-posts')}
      </Link>
    );
  }
}

NewPostMessage.propTypes = {
  header: PropTypes.object.isRequired,
  postId: PropTypes.string.isRequired,
  pathname: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  onClick: PropTypes.func,
};

const mapStateToProps = state => ({
  header: state.header,
});

const mapDispatchToProps = {
  hideNewPostMessage,
};

export default flowRight(
  connect(mapStateToProps, mapDispatchToProps),
  withTranslate
)(NewPostMessage);



// WEBPACK FOOTER //
// ./app/components/new-post-message/new-post-message.js